const checkmarkSVG = `

<?xml version="1.0" encoding="UTF-8"?>
<svg width="264px" height="264px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="checkmark" fill-rule="nonzero">
            <circle id="Oval" fill="#2ecc71" cx="132" cy="132" r="132"></circle>
            <path d="M217.312968,70.8463746 L218.744904,72.2426402 C224.67618,78.0261617 224.795958,87.5228811 219.012437,93.4541566 L117.377848,197.685246 C111.594326,203.616521 102.097607,203.7363 96.1663314,197.952778 C96.1382171,197.925364 96.1102107,197.89784 96.0823126,197.870206 L45.0297916,147.30125 C39.1441193,141.471326 39.0989262,131.973959 44.92885,126.088287 L46.3363181,124.66736 C52.1662419,118.781687 61.6636091,118.736494 67.5492814,124.566418 L106.428695,163.07757 L196.101451,71.1139069 C201.884973,65.1826314 211.381692,65.0628531 217.312968,70.8463746 Z" id="Path-2" fill="#FFFFFF"></path>
        </g>
    </g>
</svg>
`;

export default checkmarkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/checkmarkSVG.js